/**
 * Centralized motivational quotes for focus modes
 * - Starter quotes: shown when a session begins
 * - Momentum quotes: shown after the first rotation
 */

// Quotes that make sense at the START of a focus session
export const STARTER_QUOTES = [
  "Just start. The rest will follow.",
  "Every expert was once a beginner.",
  "One thing at a time.",
  "This moment matters.",
  "Show up, even when it's hard.",
  "The secret of getting ahead is getting started.",
];

// Quotes that encourage persistence AFTER you're in the flow
export const MOMENTUM_QUOTES = [
  "Keep going, you got this.",
  "You're doing better than you think.",
  "Small wins lead to big victories.",
  "Build the momentum.",
  "Progress, not perfection.",
  "You are capable of hard things.",
  "Consistent beats intense every time.",
  "Your future self will thank you.",
  "Great things take time.",
  "It doesn't matter how slow you go, as long as you don't stop.",
  "The only way to fail is to quit.",
];

/**
 * Get a random starter quote for session beginning
 */
export const getStarterQuote = (): string => {
  const randomIndex = Math.floor(Math.random() * STARTER_QUOTES.length);
  return STARTER_QUOTES[randomIndex];
};

/**
 * Get the next momentum quote, cycling through the list
 */
export const getNextMomentumQuote = (currentIndex: number): { quote: string; nextIndex: number } => {
  const nextIndex = (currentIndex + 1) % MOMENTUM_QUOTES.length;
  return {
    quote: MOMENTUM_QUOTES[nextIndex],
    nextIndex,
  };
};

/**
 * Get a random momentum quote index to start cycling from
 */
export const getRandomMomentumIndex = (): number => {
  return Math.floor(Math.random() * MOMENTUM_QUOTES.length);
};
